import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconFolderLine = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	fill: "none",
	viewBox: "0 0 40 40",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#00ABFF",
		d: "M16.667 6.667h-10c-1.833 0-3.316 1.5-3.316 3.333l-.017 20c0 1.833 1.5 3.333 3.333 3.333h26.667c1.833 0 3.333-1.5 3.333-3.333V13.333c0-1.833-1.5-3.333-3.333-3.333H20.001l-3.334-3.333z"
	})
});
export default SvgIconFolderLine;
